<template>
  <div class="my-customer" @click.stop="$emit('click')">
    <div class="icon">
      <el-icon style="color: white;font-size: 12px;">
        <UserFilled/>
      </el-icon>
    </div>
    <div class="text-box">
      我的客户
    </div>
  </div>
</template>

<script>
import { UserFilled } from '@element-plus/icons-vue'

export default {
  name: 'MyCustomer',
  components: { UserFilled },
  emits: ['click'],
}

</script>

<style lang="scss" scoped>
.my-customer {
  height: 16px;
  width: max-content;
  display: flex;
  align-items: center;
  margin-left: 4px;
  cursor: pointer;

  .icon {
    width: 18px;
    height: 100%;
    background: #1890FF;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }

  .text-box {
    text-align: center;
    width: 100%;
    line-height: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px !important;
    color: #1890FF;
    background: #EDF6FF;
    border-radius: 2px;
  }
}
</style>